module.exports = __webpack_public_path__ + "static/b_ever-74fe70433be2869ecda6621dfea4042d.jpeg";